import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Snackbar from '@mui/material/Snackbar';

import ShareIcon from '@mui/icons-material/Share';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function MainMenu(props){
    const [open, setOpen] = React.useState(false);

    const actions = [
        { icon: <ShareIcon />, name: 'Copy Link' },
    ]

    const snackbar_action =(
        <div>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setOpen(false)}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    )

    const onClickHandler = () => {
        navigator.clipboard.writeText(props.shareLink);
        setOpen(true);

    }

    return(
        <div>
            <Box sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}>
                <SpeedDial
                    ariaLabel="SpeedDial basic example"
                    sx={{ position: 'fixed', bottom: "16px", right: "16px" }}
                    icon={<SpeedDialIcon />}
                >
                    {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={onClickHandler}
                    />
                    ))}
                </SpeedDial>
            </Box>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                message="Link copied"
                action={snackbar_action}
                onClose={() => setOpen(false)}
            />
        </div>
        
    );
}

export default MainMenu